import {
  Button,
  Divider,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { timeout } from '../../../components/utils/timeout';

const PickContactFromPhoneWarning = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (localStorage.getItem('understand')) return;
    timeout(() => onOpen(), 400);
  }, [onOpen]);

  const handleUnderstand = () => {
    localStorage.setItem('understand', true);
    onClose();
  };

  return (
    <>
      <Modal
        size='xs'
        isCentered
        closeOnOverlayClick={false}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader fontSize='24px' pb='2' textAlign={'center'}>
            Notice
          </ModalHeader>
          <Divider />

          <ModalBody pt='5' pb='10'>
            <Text fontSize='15px' fontWeight={'500'}>
              Please note that the current version of safari and Opramini might
              not support picking contact from phone
            </Text>
            <br />
            <Text fontSize='15px' fontWeight={'500'}>
              You can pick contact from you contact list or type in directly
            </Text>
          </ModalBody>

          <ModalFooter>
            <Button
              variant='ghost'
              color='primary'
              size='sm'
              mr={3}
              onClick={handleUnderstand}
            >
              I understand
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default PickContactFromPhoneWarning;
